import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { CorporateFare } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import MobileRequestItem from './MobileRequestItem';
import { RequestResponseWithBuildingDTO } from '../../../../ApiOld/Api/ApiServerVov';

interface MobileRequestBuildingItemProps {
    requests: RequestResponseWithBuildingDTO[];
    buildingName: string;
    onRefresh: () => void;
}

const MobileRequestBuildingItem: React.FC<MobileRequestBuildingItemProps> = ({ requests, buildingName, onRefresh }) => {
    return (
        <Box className="mobile-request-building-item" width={'100%'} padding={1} bgcolor={'#F5F5F5'} borderRadius={'10px'} marginBottom={'8px'}>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'left'}>
                <CorporateFare color={'primary'} fontSize='small' />
                <Typography fontSize={'14px'} m={'4px'} fontWeight={'bold'} mb={'6px'} mt={'2px'}>{buildingName}</Typography>
            </Box>
            <Box mr={1}>
                {requests.map((request, index) => {
                    return <MobileRequestItem request={request} key={'request_' + request.id} onRefresh={onRefresh} />;
                })}
            </Box>
        </Box>
    );
};

export default MobileRequestBuildingItem;